import { useState } from 'react';

export const InstructivosPage = () => {
    const [selectedIndex, setSelectedIndex] = useState(null);

    const instructivos = [
        {
            titulo: 'Instructivo de inscripción para municipios al Registro Provincial de Entidades Deportivas',
            videoId: 'KdhZAjbjSZ0',
            disponible: true,
        },
        {
            titulo: 'Instructivo de inscripción para entidades al Registro Provincial de Entidades Deportivas',
            videoId: '-gi4ZwIxyiU',
            disponible: true,
        },
        {
            titulo: 'Instructivo geolocalización de sedes - Registro Provincial de Entidades Deportivas',
            videoId: 'TC9e5YKNbrY',
            disponible: true,
        },
    ];

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4">
            <div className="max-w-5xl mx-auto">
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white text-center mb-2">
                    Instructivos
                </h1>
                <p className="text-center text-gray-600 dark:text-gray-400 mb-10">
                    Registro Provincial de Entidades Deportivas
                </p>

                <div className="space-y-8">
                    {instructivos.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden"
                        >
                            <button
                                onClick={() => setSelectedIndex(selectedIndex === index ? null : index)}
                                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50 dark:hover:bg-gray-750 transition-colors"
                            >
                                <div className="flex items-center gap-3">
                                    <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold text-white ${item.disponible ? 'bg-[#476c97]' : 'bg-gray-400'}`}>
                                        {index + 1}
                                    </span>
                                    <span className="font-medium text-gray-900 dark:text-white">
                                        {item.titulo}
                                    </span>
                                </div>
                                <svg
                                    className={`w-5 h-5 text-gray-400 transition-transform ${selectedIndex === index ? 'rotate-180' : ''}`}
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>

                            {selectedIndex === index && (
                                <div className="px-6 pb-6">
                                    <div className="mt-4">
                                        {item.disponible ? (
                                            <div className="aspect-video rounded-lg overflow-hidden bg-black">
                                                <iframe
                                                    width="100%"
                                                    height="100%"
                                                    src={`https://www.youtube.com/embed/${item.videoId}`}
                                                    title={item.titulo}
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    allowFullScreen
                                                    className="w-full h-full"
                                                ></iframe>
                                            </div>
                                        ) : (
                                            <div className="aspect-video rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center">
                                                <div className="text-center text-gray-500 dark:text-gray-400">
                                                    <svg className="w-16 h-16 mx-auto mb-3 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                    </svg>
                                                    <p className="text-lg font-medium">Próximamente</p>
                                                    <p className="text-sm mt-1">Este video instructivo estará disponible pronto.</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div className="mt-12 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6 text-center">
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                        Contacto
                    </h2>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
                        Para dudas o consultas sobre el registro escribinos a:
                    </p>
                    <a
                        href="mailto:registroentidadesdeportivas@gmail.com"
                        className="text-sm font-medium text-[#476c97] hover:underline"
                    >
                        registroentidadesdeportivas@gmail.com
                    </a>
                </div>
            </div>
        </div>
    );
};
